import React from "react";

const NavBar = () => {
  return (
    <div className="flex h-14 w-[100%]items-center justify-center bg-slate-800">
      <h1 className="text-4xl decoration-dashed	font-semibold absolute mt-9 z-50 text-slate-200 ">
        CodeMaster
      </h1>
    </div>
  );
};

export default NavBar;
